
import React from "react";
import { Button } from "@/components/ui/button";
import { Check, FilterX } from "lucide-react";
import { useTranslations } from "use-intl";

interface FilterActionsProps {
  onApply: () => void;
  onReset: () => void;
}

const FilterActions: React.FC<FilterActionsProps> = ({ onApply, onReset }) => {
  const t = useTranslations("consultantPayables.filters");
  return (
    <div className="flex justify-between mt-4">
      <Button 
        variant="default" 
        size="sm" 
        onClick={onApply}
        className="mr-2"
      >
        <Check className="mr-2 h-4 w-4" />
        {t("apply")}
      </Button>
      
      <Button 
        variant="outline" 
        size="sm" 
        onClick={onReset}
      >
        <FilterX className="mr-2 h-4 w-4" />
        {t("reset")}
      </Button>
    </div>
  );
};

export default FilterActions;
